<div class="auth-wrapper auth-v1 px-2 twofa-section">
	<div class="global-rllipse"></div>
	<div class="auth-inner py-2">
		<div class="card mb-0">
			<div class="card-body">
				<div class="w-100 text-center mb-2">
					<img src="assets/images/logo/logo-white.png" alt="logo" height="60" />
				</div>
				<div class="twofa-form-header">
					<h2>{{ 'TWO_FACTOR_AUTH.GREETING.TITLE' | translate }}</h2>
					<p class="mx-auto w-100 mb-2">{{queryParameter.message}}</p>
				</div>
				<form [formGroup]="codePanelForm" class="mb-2" (ngSubmit)="onSubmit()">
					<div class="row">
						<div class="col-12">
							<text-input class="code-input" [label]="'TWO_FACTOR_AUTH.ENTER_CODE' | translate" [id]="'twofa-code'"
								formControlName="code" [submitted]="submitted" [displayErrorMessage]="false"
								[maxlength]="6" (keypress)="numericOnly($event)"></text-input>
						</div>
						<div class="col-12">
							<button type="submit" [disabled]="loading" class="btn btn-primary btn-block" rippleEffect>
								<span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
								{{ 'TWO_FACTOR_AUTH.CONTINUE' | translate }}
							</button>
						</div>
						<ng-container *ngIf="queryParameter.twoFactorAuth">
							<div class="col-12 mt-1"
								*ngIf="queryParameter.twoFactorAuth[0] && queryParameter.twoFactorAuth[0].icon">
								<p class="resend-hint">{{ 'TWO_FACTOR_AUTH.DIDNT_RECEIVE' | translate }}
									<a id="resend-the-code" (click)="resendFunction($event)">
										<i class="feather" [ngClass]="queryParameter.twoFactorAuth[0].icon"></i>
										{{queryParameter.twoFactorAuth[0].text}}
									</a>
								</p>
							</div>
						</ng-container>
					</div>
				</form>
				<p class="text-center other-method-hint">
					<a routerLink="/login" id="back-to-login"><i class="feather icon-chevron-left"></i> {{ 'TWO_FACTOR_AUTH.BACK_TO_LOGIN' | translate }}</a>
					<ng-container *ngIf="queryParameter?.twoFactorAuth?.length > 1">
						{{ 'TWO_FACTOR_AUTH.OR' | translate }} <a id="try-another-method" (click)="backupFunction($event)">{{ 'TWO_FACTOR_AUTH.TRY_BACKUP' | translate }}</a>
					</ng-container>
				</p>
			</div>
		</div>
	</div>
</div>
